function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arch_outline_stroke{fill:none;stroke:currentColor;stroke-width:3;stroke-miterlimit:10;stroke-dasharray: 9.5 7;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "arch_outline"
}, /*#__PURE__*/React.createElement("path", {
  className: "arch_outline_fill",
  d: "M33.9,15.8c7.1,1.2,12.4,7.4,12.4,14.8v30h10v-55l5-5h-60l5,5v55h10v-30c0-7.4,5.4-13.5,12.4-14.8l0.4,2.3 h4.3C33.5,18,33.9,15.8,33.9,15.8z"
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 16.3,
  y1: 60.5,
  x2: 18.3,
  y2: 60.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 4.3,
  y1: 60.5,
  x2: 6.3,
  y2: 60.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 56.3,
  y1: 60.5,
  x2: 58.3,
  y2: 60.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 44.3,
  y1: 60.5,
  x2: 46.3,
  y2: 60.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 16.3,
  y1: 30.5,
  x2: 18.3,
  y2: 30.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 4.3,
  y1: 30.5,
  x2: 6.3,
  y2: 30.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 56.3,
  y1: 30.5,
  x2: 58.3,
  y2: 30.5
}), /*#__PURE__*/React.createElement("line", {
  className: "arch_outline_stroke",
  x1: 44.3,
  y1: 30.5,
  x2: 46.3,
  y2: 30.5
}), /*#__PURE__*/React.createElement("path", {
  className: "arch_outline_stroke",
  d: "M56.3,5.5v55h-10v-30c0-7.4-5.4-13.5-12.4-14.8L33.5,18h-4.3l-0.4-2.3c-7.1,1.2-12.4,7.4-12.4,14.8v30h-10 v-55l-5-5h60L56.3,5.5z"
}));

var SvgArchOutline = function SvgArchOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "archOutlineIcon",
    viewBox: "-2 -2 66.61 65.08",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArchOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arch_outline.697d72a7.svg";
export { ForwardRef as ReactComponent };